// Module
var code = "<template>\n  <div class=\"form-element\">\n    <label for=\"name\" t=\"pens.sdr\"></label>\n    <numeric-input type=\"text\" name=\"sdr\" value.bind=\"penPipeSdr.SDR\" />\n  </div>\n  <div if.bind=\"isDuplicate\" style=\"margin-bottom: 1rem\"><span class=\"warning\" t=\"pens.duplicatePipeSDR\"></span></div>\n</template>\n";
// Exports
export default code;